import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import Banner from '../styled/components/single-column-banner';

type Props = {
  secondLineText: string;
};

const TrialBanner = ({ secondLineText }: Props) => (
  <Banner role='complementary'>
    <SRow className='pad-top-md'>
      <SCol span='12' center=''>
        <p className='first-line'>{t('client.general.avalara-developer')}</p>
        <p className='second-line'>{secondLineText}</p>
      </SCol>
    </SRow>
  </Banner>
);
export default TrialBanner;
